import { CompositeDecorator } from 'draft-js';
import { filterHyperlinkCharacters, linkify, REGEXP_MENTION } from './helpers';
import EditorLink from '../blocks/EditorLink';
import EditorMention from '../blocks/EditorMention';
import EditorHyperlink from 'components/common/DraftEditor/blocks/EditorHyperlink';

// Function describes strategy for links searching
const linksStrategy = (contentBlock, callback) => {
  // Find all links in text
  let links = null;
  if (contentBlock.get('type') !== 'code-block') {
    links = linkify.match(contentBlock.get('text'));
  }

  // Apply decorator to links
  if (typeof links !== 'undefined' && links !== null) {
    for (let i = 0; i < links.length; i += 1) {
      callback(links[i].index, links[i].lastIndex);
    }
  }
};

// Function describe strategy for mentions searching
const mentionsStrategy = (contentBlock, callback) => {
  if (typeof contentBlock.get('text') !== 'string') {
    return;
  }

  let mentions = contentBlock.get('text')?.matchAll(REGEXP_MENTION);

  if (mentions) {
    mentions = [...mentions];

    for (let index in mentions) {
      const mention = mentions[index];

      callback(mention.index, mention.index + mention[0].length);
    }
  }
};

// Function describe strategy for hyperlinks searching
const hyperlinkStrategy = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(
    (character) => {
      return filterHyperlinkCharacters(character, contentState);
    },
    (start, end) => {
      callback(start, end);
    },
  );
};

// List of enabled decorators for editor
export const compositeDecorator = new CompositeDecorator([
  {
    strategy: linksStrategy,
    component: EditorLink,
  },
  {
    strategy: mentionsStrategy,
    component: EditorMention,
  },
  {
    strategy: hyperlinkStrategy,
    component: EditorHyperlink,
  },
]);

export default { compositeDecorator };
